export const IS_MOBILE = window.innerWidth <= 760;
export const DATE_FORMAT = IS_MOBILE ? "dd M/D/YY" : "dddd M/D/YY";
// Below must add to COL_LABEL_SIZE + COL_CELL_SIZE*7 = 24
export const COL_LABEL_SIZE = 10;
export const COL_CELL_SIZE = 2;
